import { ChangeDetectionStrategy, Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { OptionTypeService } from 'app/modules/option-type/services/option-type.service';
import module from 'app/modules/option-type/option-type.module';

@Component({
  selector: 'app-add-option-type-details',
  templateUrl: './add-option-type-details.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: module,
  styleUrls: ['./add-option-type-details.component.scss']
})
export class AddOptionTypeDetailsComponent {
  public optionItem : any = {
    optionId : this.optionId,
    name : '',
    alternate : ''
  }

  public isLoading: boolean = false

  constructor(
    public dialogRef: MatDialogRef<AddOptionTypeDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public optionId: any,
    public dialog: MatDialog,
    private metadataService: OptionTypeService) { 
    }

    addOptionsItem() {
      this.isLoading = true
  
      this.metadataService.createOptionItem(this.optionItem).subscribe((res)=>{
        this.isLoading = false
        this.closeDialog()
      })
    }
  
    closeDialog(): void {
      this.dialogRef.close(true);
    }



}
